import React from 'react'

import { Suspense } from '~/components/elements/Suspense'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'
import { useSurveyForSettingsQuery } from '~/hooks/useSurveyForSettingsQuery'

import { SurveySettings } from './components/SurveySettings'

export const SurveySettingsPage = () => {
  const { isLoading } = useSurveyForSettingsQuery()

  useLogEventOnMount('Access to general survey information')

  return (
    <Suspense loading={isLoading}>
      <SurveySettings />
    </Suspense>
  )
}
